import type { RecruitStatus } from '@/types/recruitment';

/**
 * Recruiting status → shared kit pill class. Same soft-tinted grammar as the
 * Prospects stage badges (see the `.badge--*` rules in @/components/lw/theme.css),
 * so the two Talent Pipeline tabs read as siblings.
 */
export const RECRUIT_STATUS_BADGE: Record<RecruitStatus, { label: string; badgeClass: string }> = {
  Inquiry: { label: 'Inquiry', badgeClass: 'badge--inquiry' },
  Pending: { label: 'Pending', badgeClass: 'badge--pending' },
  'In Progress': { label: 'In Progress', badgeClass: 'badge--inprogress' },
  Approved: { label: 'Approved', badgeClass: 'badge--approved' },
  Denied: { label: 'Denied', badgeClass: 'badge--denied' },
  'On Hold': { label: 'On Hold', badgeClass: 'badge--onhold' },
  Terminated: { label: 'Terminated', badgeClass: 'badge--terminated' }
};

export const recruitStatusBadge = (status: RecruitStatus) =>
  RECRUIT_STATUS_BADGE[status] ?? { label: status as string, badgeClass: 'badge--inquiry' };
